import React, { memo, useCallback, useEffect } from "react";
import { Card, Input, Controller, Button } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, message } from "antd";
import {
  useGetAuthorityFindCategory,
  usePatchAuthorityUpdateCategory,
} from "core";
import LoadingView from "../../atoms/loadingView";
import { useParams } from "react-router-dom";

const NAME = "name";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditCategory = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const { id } = useParams();
  
  const { data:dataCategory , isFetching: isFetchingRole,isFetched,refetch } =
    useGetAuthorityFindCategory({pageNumber:"1",pageSize:'1',id:id});



    
    useEffect(() => {
      if (isFetched) {
        reset({
          name:dataCategory?.data?.categories?.[0]?.name
        });
      }
      
  }, [dataCategory]);

  const methods = useForm({
    defaultValues: {
      name: "",
    },
  });

  const { handleSubmit, reset } = methods;
  const { mutate, isPending } = usePatchAuthorityUpdateCategory({
    onSuccess: () => {
      messageApi.open({
        type: 'success',
        content: i18n.t('done'),
      });
      reset();
      refetch()
    },
  });

  const onSubmit = useCallback(
    ({ name }: { name: any }) => {
      mutate({
        requestBody: {
          id:id || "",
          name: name,
        },
      });
    },
    []
  );

  
  return (
    <>
      {contextHolder}

      <LoadingView isLoading={isFetchingRole}>
        <Card title={i18n.t("editCategory")}>
          <FormProvider {...methods}>
            <Form
              {...layout}
              name="nest-messages"
              onFinish={handleSubmit(onSubmit)}
            >
              <Form.Item>
                <Controller name={NAME}>
                  <Input placeholder={i18n.t("categoryName")} />
                </Controller>
              </Form.Item>
              <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
                <Button
                  style={{ width: "100px" }}
                  type="primary"
                  isLoading={isPending}
                  htmlType="submit"
                >
                  {i18n.t("update")}
                </Button>
              </Form.Item>
            </Form>
          </FormProvider>
        </Card>
      </LoadingView>
    </>
  );
});
export { EditCategory };
